export const pageLevels = {
  derivative: "derivative",
  model: "model",
  range: "range",
};